// @core/api/endpoints/calendar/invite_attendees.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  InviteAttendeesRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Invite attendees
 * Adds one or more attendees to an event with specified roles (required, optional, chair). Invitations are sent via notification.
 */
export async function InviteAttendees(
  event_id: string,
  data: InviteAttendeesRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/attendees`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
